import ApiStatuses from '@/entities/enums/apiStatuses';
import LoggedUserManager from '@/services/LoggedUserManager';
import i18n from '@/lang/lang';
import ApiResponseCodes from '@/entities/enums/apiResponseCodes';
import { vxm } from '@/store/store.vuex';
import { NotificationProgrammatic as Notification } from 'buefy';
import router from '@/router';
var vxDepartmentStore = vxm.departmentStore;
import { FeaturesManager } from '@/entities/tiers/FeaturesManager';
export function processError(error) {
    let response = error.response;
    if (!response) {
        // Network-level error (no HTTP response): server unreachable, CORS, timeout, or cancelled request.
        // Nothing to process — return undefined so callers can short-circuit.
        return undefined;
    }
    // showFatalErrorMsg(self, response);
    let status = response.status;
    /* if departmentId NOT_FOUND or NOT_VALID, reload to
     * dashboard with favorite department / first from list of departments
     */
    switch (status) {
        case ApiStatuses.NOT_FOUND: {
            let responseData = response?.data;
            if (responseData instanceof ArrayBuffer)
                responseData = arrayBufferToString(response.data);
            if (response?.data?.code === ApiResponseCodes.DEPARTMENT_NOT_FOUND) {
                let id = getSelectedDepartmentId();
                router.replace({
                    name: 'dashboard',
                    params: { departmentId: id, lang: router.currentRoute.params.lang }
                });
                showDepartmentErrorMsg();
            }
            else if (response?.data?.code === ApiResponseCodes.FLOOR_PLAN_NOT_FOUND ||
                responseData.code === ApiResponseCodes.FLOOR_PLAN_NOT_FOUND) {
                break;
            }
            else if (response?.data?.code === ApiResponseCodes.RESELLER_NOT_FOUND) {
                showResellerNotAssignedErrorMsg();
                break;
            }
            else {
                showFatalErrorMsg(response);
            }
            break;
        }
        case ApiStatuses.BAD_REQUEST: {
            if (response?.data?.code === ApiResponseCodes.VALIDATION_ERROR && 'departmentId' in response?.data?.errors) {
                let id = getSelectedDepartmentId();
                router.replace({
                    name: 'dashboard',
                    params: { departmentId: id, lang: router.currentRoute.params.lang }
                });
                showDepartmentErrorMsg();
            }
            else if (response?.data?.code === ApiResponseCodes.VALIDATION_ERROR && 'Email' in response?.data?.errors) {
                break;
            }
            else if (response?.data?.code === ApiResponseCodes.PROD_NUMBER_IN_USE) {
                break;
            }
            else {
                showFatalErrorMsg(response);
            }
            break;
        }
        case ApiStatuses.UNAUTHORIZED: {
            if (!LoggedUserManager.startExpirationHandling())
                return response;
            manageCredentialExpiration();
            return response;
        }
        case ApiStatuses.NOT_ALLOWED: {
            let responseData = response?.data;
            if (responseData instanceof ArrayBuffer)
                responseData = arrayBufferToString(response.data);
            if (responseData.code === ApiResponseCodes.QUOTA_REACHED)
                FeaturesManager.showQuotaReachedMsg();
            else if (responseData.code === ApiResponseCodes.FEATURE_DISABLED)
                FeaturesManager.showFeatureDisabledMsg();
            else
                showFatalErrorMsg(response);
            break;
        }
        default:
            showFatalErrorMsg(response);
            throw response;
            break;
    }
    return response;
}
function arrayBufferToString(buffer) {
    let result = new TextDecoder('utf-8').decode(buffer);
    return JSON.parse(result);
}
function showDepartmentErrorMsg() {
    Notification.open({
        message: `<strong>${i18n.t('error_messages.department_not_found')}</strong>`,
        duration: 4000,
        position: 'is-top-right',
        type: 'is-warning',
        queue: false
    });
}
function showResellerNotAssignedErrorMsg() {
    Notification.open({
        message: `<strong>${i18n.t('error_messages.reseller_not_found')}</strong>`,
        duration: 4000,
        position: 'is-top-right',
        type: 'is-warning',
        queue: false
    });
}
function showFatalErrorMsg(response) {
    console.log(response);
    let text = '';
    if (response.data)
        text = JSON.stringify(response.data);
    else if (response.statusText)
        text = JSON.stringify(response.statusText);
    Notification.open({
        message: `<strong>${i18n.t('error_messages.fatal_error')}</strong> </br> ${text}`,
        duration: 4000,
        position: 'is-top-right',
        type: 'is-warning',
        queue: false
    });
}
function manageCredentialExpiration() {
    try {
        router instanceof TypeError;
    }
    catch (err) {
        LoggedUserManager.deleteLoginData();
        LoggedUserManager.deleteAdminLoginData();
        location.reload();
        return;
    }
    if (router == null)
        return;
    LoggedUserManager.deleteLoginData();
    LoggedUserManager.deleteAdminLoginData();
    router
        .push({
        name: 'login',
        params: {
            lang: router.currentRoute.params.lang
        }
    })
        .catch((err) => err);
    Notification.open({
        message: i18n.t('error_messages.unauthorized_msg'),
        duration: 4000,
        position: 'is-top-right',
        type: 'is-warning',
        queue: false
    });
}
function getSelectedDepartmentId() {
    return vxDepartmentStore.selectedDepartment.id;
}
